<script lang="ts" setup>
import type { ConsultationSourceEnumType } from '@forgd/contract/types'
import { ConsultationSourceEnum } from '@forgd/contract/types'
import { Button } from '@forgd/ui-kit/button'
import { CalendarDaysIcon } from '@heroicons/vue/24/outline'

const props = withDefaults(defineProps<{
  source?: ConsultationSourceEnumType
  showAdvisors?: boolean
}>(), {
  source: ConsultationSourceEnum.HomepageAdvisory,
  showAdvisors: true,
})

const { destination } = useConsultationDestination()
const { captureConsultationClick } = useConsultationTracking()

function bookConsultation() {
  captureConsultationClick(props.source, destination.value.to)
}
</script>

<template>
  <CoreGradientBanner
    data-el="CoreFullServiceAdvisoryBanner"
    class="@container rounded-lg shadow-card"
  >
    <div class="relative flex flex-col gap-6 p-5 @md:flex-row @md:flex-wrap @md:items-center @md:gap-5 @md:pr-10">
      <CoreToolsPictogram
        variant="dark"
        class="block size-[85px] shrink-0 @md:size-[100px]"
      />

      <div class="flex flex-1 flex-col gap-5">
        <div class="flex flex-col gap-1">
          <h3 class="text-base font-semibold leading-6 text-white">
            Bespoke Full-Service Advisory
          </h3>
          <p class="max-w-[520px] text-sm leading-[21px] text-white">
            From tokenomics design, market maker engagements, &amp; launch underwriting; pave the way for your successful launch and growth.
          </p>
        </div>
        <Button as-child variant="outline-inverted" size="sm" class="self-start">
          <NuxtLink
            :to="destination.to"
            :external="destination.external"
            :target="destination.target"
            :rel="destination.external ? 'noopener noreferrer' : undefined"
            @click="bookConsultation"
          >
            Book a Consultation
            <CalendarDaysIcon />
          </NuxtLink>
        </Button>
      </div>

      <a
        v-if="showAdvisors"
        href="/about/advisory"
        rel="noopener noreferrer"
        class="flex w-full items-center justify-between gap-3 rounded-lg border border-neutral-900/30 bg-page py-2 pl-4 pr-2 transition-opacity hover:opacity-90 @3xl:ml-auto @3xl:w-auto @3xl:shrink-0 @3xl:justify-start"
      >
        <div class="flex flex-col">
          <span class="text-xs leading-[18px] text-secondary">Start with an Expert</span>
          <span class="text-sm font-semibold leading-[21px] text-primal">Meet the advisors</span>
        </div>
        <div class="relative h-16 w-22 shrink-0">
          <div class="absolute left-4 top-2 size-13 rounded-lg border border-brand-300" />
          <img src="/images/advisory/scott.png" alt="" class="absolute left-0 top-0 size-11 rounded object-cover">
          <img src="/images/advisory/shane.png" alt="" class="absolute bottom-0 right-0 size-12 rounded object-cover ring-2 ring-neutral-200">
        </div>
      </a>
    </div>
  </CoreGradientBanner>
</template>
